import React, { Component } from "react"

/* Constants */
import { env } from "../constants"

/* Components */
import { Picture, Card } from "@cuba-go/poker-ui"

/* utils */
import { get_unique_values } from "../constants/utils"

/* Fields */
const PLAYER_SPACES = ['1', '2']


/* Widget uMP Player Cards */
class UMPPlayerCards extends Component {

    constructor(props) {
        super(props)
    }

    /* Card status */
    status = card => {

        const { game } = this.props

        let status = false

        if (game && game.data) {
            const index = game.data.findIndex(e => parseInt(e.id) === parseInt(card.id))
            if (index > -1) {
                if (game.data[index].status) {
                    status = true
                }
            }
        }

        return status
    }


    /* Draw card image */
    _image = card => {
        const status = this.status(card)
        let style = status ? 'ump--animated-card-image' : ''
        return <Card className={style} data={card.name} />
    }


    /* Draw flip animation box */
    _flip = card => {
        return (
            <div className={`ump--player-flip-card active`}>
                <div className="ump--player-flip-card-inner">
                    <div className="ump--player-flip-card-front">
                        <Card closed={true} />
                    </div>
                    <div className="ump--player-flip-card-back">
                        {this._image(card)}
                    </div>
                </div>
            </div>
        )
    }


    /* Draw Status */
    _status = (card, key) => {
        const status = this.status(card)
        let style = ''
        if (card.player) {
            style += 'player-card'
        }

        return (
            <div className={`ump--player-game-status ${status ? 'ump--player-game-status-animation' : ''}`} key={key}>
                <div className={`ump--player-game-status-corner ${style}`} />
            </div>
        )

    }

    /* Draw Player cards */
    _player = () => {

        const { cards, isExchange, used } = this.props
        const tapScreenStatus = cards && cards.length === 5 && !used

        const filtered_cards = cards ? get_unique_values(cards, "id") : []

        return (
            <div className="ump--player-box">

                <div className={`ump--player-cards ${isExchange ? 'ump--player-exchange-cards' : ''}`}>
                    {filtered_cards.map(card => {
                        const cardKey = (card.uid ? card.uid : card.id)
                        return (
                            <div key={`card_${cardKey}`} className={`ump--player-card  ${tapScreenStatus ? 'ump--player-card-tap' : ''}`}>
                                {this._flip(card)}
                            </div>
                        )
                    })}
                </div>

                <div className="ump--player-cards-places">
                    {PLAYER_SPACES.map((item) => {
                        return (
                            <div key={`place-${item}`} className={`ump--player-card-place ${tapScreenStatus ? 'ump--player-card-place-tap' : ''}`}></div>

                        )
                    })}
                </div>

            </div>
        )
    }


    /* Draw player game result */
    _result = () => {

        const { game } = this.props

        let result = ""
        if (game) {
            if (parseInt(game.level) === 0) {
                result = "Нет игры"
            }
            if (parseInt(game.level) > 0) {
                result = game.name
                if (game.hasAceKing) {
                    result = result + " + Туз Король"
                }
            }
        }

        if (result !== "") {
            if (result === "Нет игры") {
                return <div className={`ump--player-result ump--player-result-red`}>{result}</div>
            }
            else {
                return <div className={`ump--player-result`}>{result}</div>
            }
        }
    }


    /* Draw Player Cards */
    _playerBox = () => {

        const { box } = this.props

        return (
            <div className="ump--player">
                <h2>Бокс - {box + 1}</h2>
                {this._player()}
                {this._result()}
            </div>
        )
    }


    render = () => {

        const { style, action, box, gameBox, isPlayerGameBox, pass, length } = this.props

        const dark = (gameBox || gameBox === 0) && gameBox !== box && isPlayerGameBox
        const activeBox = (gameBox || gameBox === 0) && gameBox === box

        return (
            <div className={`ump-player-game ${(box === 1 && length === 3) ? "center-test" : ""}`} style={{ opacity: dark ? 0.45 : 1 }} key={`boxcards-${box}`}>
                <div className={`ump--player-card-container ${style}`}>
                    {this._playerBox()}
                </div>
                <div className="ump-player-helper">
                    {
                        activeBox ?
                            <div className="active-arrow">
                                <img src="/images/arrow.png" alt="arrow" />
                            </div>
                            : null
                    }
                </div>
            </div>
        )
    }

}

export default UMPPlayerCards